import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, imgUrl, STATUS_LABELS } from "../../lib/api";
import { PageTitle, Card } from "./AdminUI";

export default function ProjectsAdmin() {
  const qc = useQueryClient();
  const { data: items = [] } = useQuery({ queryKey: ["admin-projects"], queryFn: () => api.get("/admin/projects").then((r) => r.data) });
  const del = async (p) => {
    if (!window.confirm(`Eliminare il progetto "${p.title}"?`)) return;
    await api.delete(`/admin/projects/${p.id}`);
    toast.success("Progetto eliminato");
    qc.invalidateQueries({ queryKey: ["admin-projects"] });
    qc.invalidateQueries({ queryKey: ["projects"] });
  };
  return (
    <div data-testid="admin-projects">
      <PageTitle title="Progetti" subtitle={`${items.length} progetti`} action={<Link to="/admin/progetti/nuovo" data-testid="admin-project-new" className="btn-primary !py-2.5 !px-5"><Plus size={14} /> Nuovo progetto</Link>} />
      <Card className="!p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs uppercase tracking-wider text-stone"><tr><th className="text-left p-4 font-medium">Progetto</th><th className="text-left p-4 font-medium hidden md:table-cell">Città</th><th className="text-left p-4 font-medium hidden md:table-cell">Stato</th><th className="text-left p-4 font-medium">Visibilità</th><th className="p-4" /></tr></thead>
          <tbody className="divide-y divide-gray-100">
            {items.map((p) => (
              <tr key={p.id} data-testid={`admin-project-row-${p.slug}`} className="hover:bg-gray-50">
                <td className="p-4"><div className="flex items-center gap-3"><div className="w-14 h-10 bg-gray-100 rounded overflow-hidden shrink-0">{p.cover_image && <img src={imgUrl(p.cover_image)} alt="" className="img-cover" />}</div><div><div className="font-medium">{p.title}</div><div className="text-xs text-stone">/{p.slug}</div></div></div></td>
                <td className="p-4 hidden md:table-cell">{p.city}</td>
                <td className="p-4 hidden md:table-cell">{STATUS_LABELS[p.status]}</td>
                <td className="p-4"><span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded ${p.published ? "bg-green-50 text-green-700" : "bg-gray-100 text-stone"}`}>{p.published ? "Pubblicato" : "Bozza"}</span>{p.featured && <span className="ml-2 text-[10px] uppercase tracking-wider px-2 py-1 rounded bg-gold/20 text-ink">Home</span>}</td>
                <td className="p-4 text-right whitespace-nowrap"><Link to={`/admin/progetti/${p.id}`} data-testid={`admin-project-edit-${p.slug}`} className="inline-flex p-2 text-stone hover:text-ink"><Pencil size={15} /></Link><button onClick={() => del(p)} data-testid={`admin-project-delete-${p.slug}`} className="inline-flex p-2 text-stone hover:text-red-600"><Trash2 size={15} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
